import { AppImageDisplayInfo, RenderImageType } from "client/Api/AppIcon/common";
import classNames from "classnames";
import {
	AppIcon,
	Icon,
	FontIconName
} from "client/Components";
import { isNotNil, setTrackingId } from "client/Misc/utils";
import {
	KeyboardEvent,
	ReactElement,
	Ref
} from "react";
import { getReactColorAttributes } from "client_legacy/ndaw/appColor";
import { AppColorViewModel } from "client/Api/Apps/common";
import styles from "./FrequentlyUsedTileVisual.module.less";

export type FrequentlyUsedTileVisualProps = {
	ref?: Ref<HTMLButtonElement>;
	name: string;
	icon: AppImageDisplayInfo;
	color: AppColorViewModel;
	isDisabled?: boolean;
	statusIcon?: FontIconName | nil;
	tooltip?: string;
	isRenderedOnBackground?: boolean;
	onClick?: () => void;
	onKeyDown?: (event: KeyboardEvent<HTMLButtonElement>) => void;
	tabIndex?: number;
	trackingId?: string;
};

export const FrequentlyUsedTileVisual = (props: FrequentlyUsedTileVisualProps): ReactElement => {
	const {
		ref,
		name,
		icon,
		isDisabled = false,
		statusIcon,
		tooltip,
		isRenderedOnBackground = false,
		onClick,
		onKeyDown,
		tabIndex,
		color,
		trackingId
	} = props;

	const { colorClass, colorStyle } = getReactColorAttributes(color);

	return (
		<button
			ref={ref}
			{...setTrackingId(trackingId)}
			className={classNames(
				styles.root,
				{
					[styles.root_disabled]: isDisabled,
					[styles.root_hasStatusIcon]: isNotNil(statusIcon),
					[styles.root_background]: isRenderedOnBackground
				}
			)}
			onClick={onClick}
			onKeyDown={onKeyDown}
			tabIndex={tabIndex}
			title={tooltip}
		>
			{statusIcon && (
				<div className={styles.statusIcon}>
					<Icon
						value={{
							kind: "font",
							name: statusIcon,
							color: "danger"
						}}
						size="large"
					/>
				</div>
			)}
			<div
				className={
					classNames(
						styles.icon,
						colorClass,
						{
							[styles.icon_colorizedSvg]: icon.renderType === RenderImageType.ColorizableSvg,
							[styles.icon_raster]: icon.renderType === RenderImageType.Raster
						}
					)
				}
				style={colorStyle}
			>
				<AppIcon
					value={icon}
					color="inherit"
				/>
			</div>
			<div className={styles.nameContainer}>
				<div className={styles.name}>
					{name}
				</div>
			</div>
		</button>
	);
};
FrequentlyUsedTileVisual.displayName = "FrequentlyUsedTileVisual";